import React from 'react';

export const HemXBadge: React.FC = (): JSX.Element => {
  return (
    <span
      className="absolute bottom-2 right-2 flex h-16 w-16 scale-75 items-center justify-center whitespace-nowrap rounded-full bg-hem-x text-base font-bold text-white md:bottom-3 md:right-3 md:scale-90 ml:bottom-4
      ml:right-4 ml:scale-100"
    >
      Hem X
    </span>
  );
};
